import annaAhmatova from './anna_ahmatova';
import elenaMihajlik from './elena_mihajlik';
import aleksandrBlok from './aleksandr_blok';
import fedorTjutĉev from './fedor_tutĉev';
import irinaRatuŝinskaja from './irina_ratuŝinskaja';
import andrejVoznesenskij from './andrej_voznesenskij';
import konstantinBalmont from './konstantin_balmont';
import aleksandrPuŝkin from './aleksandr_puŝkin';
import marinaCvetaeva from './marina_cvetaeva';
import dEgorov from './d_egorov';
import mihailLermontov from './mihail_lermontov';
import nikolajGumilev from './nikolaj_gumilev';
import ŝarlBodler from './ŝarl_bodler';
import vladimirMajakovskij from './vladimir_majakovskij';
import nikolajNekrasov from './nikolaj_nekrasov';
import elza_beskow from './elza_beskow';
import julian_tuwim from './julian_tuwim';
import maksimilian_volosxin from './maksimilian_volosxin';

const list = [
  annaAhmatova,
  aleksandrBlok,
  konstantinBalmont,
  ŝarlBodler,
  marinaCvetaeva,
  dEgorov,
  nikolajGumilev,
  mihailLermontov,
  vladimirMajakovskij,
  elenaMihajlik,
  aleksandrPuŝkin,
  irinaRatuŝinskaja,
  fedorTjutĉev,
  andrejVoznesenskij,
  nikolajNekrasov,
  elza_beskow,
  julian_tuwim,
  maksimilian_volosxin
];

export default list;